import { styled, Stack } from '@ltvco/refresh-lib/theme';

export const ReportBannerContainer = styled(Stack)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: '16px',
  marginBottom: theme.spacing(2.5),
  paddingBottom: theme.spacing(2.5),
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
  },
}));
